module.exports = __webpack_public_path__ + "static/img/anquanjiance.982a2f80.svg";